import React, { useEffect, useState } from "react";
import moment from "moment";
import _ from "lodash";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { bindActionCreators, compose } from "redux";
import { IconButton } from "@material-ui/core";
import {
  LabeledButtonWithCount,
  MaterialIcon,
  LabelString,
  LabelDollarFormatted,
  ModuleAccordionGroup,
  ModuleAccordionSection,
  ModuleAccordionSummary
} from "@loanbossinc/component-library";
import FolderIcon from "@material-ui/icons/Folder";
import SimpleConfirmDialog from "components/Global/ConfirmationDialogs/SimpleConfirmDialog";
import { CardPageLayout } from "component-lib/CardPageLayout";
import { CustomizableHeroCard } from "component-lib/CustomizableHeroCard";
import UserConfirmationModal from "modals/UserConfirmationModal/UserConfirmationModal";

import ConfigPageDisclaimer from "../../configurationPageDisclaimer";
import LenderReportingDrawer from "../../../drawer";
import { dealGet } from "../../../../deal/deal.store";
import { actionCreators as dashboardActionCreators } from "../../../dashboard/dashboard.store";
import { actionCreators as dscrSetupActionCreators } from "../../../reportComponentsSetup/dscrSetup/dscrSetup.store";
import { actionCreators as dscrDrawerActionCreators } from "../../../drawer/dscr-line-items-management/dscrLineItemManagement.store";
import { actionCreators as reportComponentActionCreators } from "../../reportComponent.store";
import { actionCreators as reportConfigActionCreators } from "../../../reportingSetup/reportingSetup.store";
import { actionCreators as dscrCalculationActionCreators } from "./dscrProjectedCalculationDashboard.store";
import {
  StickyWrapper,
  LabeledIconWrapper,
  Container
} from "../../../dashboard/styles";
import { ListItemContent, ListItemText, ListItemTitle } from "../../styles";
import calcIcon from "../../../calcIcon.svg";

import {
  StyledButtonText,
  LineItemRowContainer,
  LineItemRowButtons,
  LineItemDescription
} from "../styles";

import {
  SourceFileTypeWrapper,
  PropertyNameWrapper,
  UploadDateWrapper
} from "../../debtYieldCalculationDashboard/styles";

const formattedDollarLabel = (value, fontWeight = "bold") => (
  <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
    <LabelDollarFormatted
      value={(value && Math.abs(value)) || " "}
      hasAccountingFormat={value < 0}
      decimals={2}
      style={{ fontWeight, color: value < 0 ? "#C40A0A" : "#000" }}
    />
  </div>
);

const LineItemRow = props => {
  const {
    setDscrCalculationDashboardSelections,
    lineItem,
    loanId,
    handleEditLineItem
  } = props;

  const handleOpenLineItemDeleteDialog = () => {
    setDscrCalculationDashboardSelections({
      isDeleteDialogOpen: true,
      activeLoanId: loanId
    });
  };

  return (
    <LineItemRowContainer style={{ height:80 }}>
      <LineItemRowButtons>
        <IconButton style={{ color: "#C4C4C4" }} onClick={handleEditLineItem}>
          <MaterialIcon iconName="create" />
        </IconButton>
        <IconButton
          style={{ color: "#C4C4C4" }}
          onClick={handleOpenLineItemDeleteDialog}
        >
          <MaterialIcon iconName="delete" />
        </IconButton>
      </LineItemRowButtons>
      {lineItem.type === "From file" ? (
        setLineItemAccordingToFieldType(lineItem)
      ) : (<LineItemDescription>{lineItem.type}</LineItemDescription>)}
        {formattedDollarLabel(lineItem.value, "400")}
      </LineItemRowContainer>
    );
};

const setLineItemAccordingToFieldType = lineItem => {
  const { selectedFromFileField } = lineItem;
  return (
    selectedFromFileField.lineItemType === "fromFile" ? (
      <LineItemDescription>
        <SourceFileTypeWrapper>
          {_.startCase(`${selectedFromFileField.sourceName} ${selectedFromFileField.fileTypeName}`)}
        </SourceFileTypeWrapper>
        <UploadDateWrapper>
          {`Uploaded on ${moment
            .utc(selectedFromFileField.fileCreatedAt)
            .format("MMMM DD, YYYY")}`}
        </UploadDateWrapper>
        <PropertyNameWrapper>{selectedFromFileField.name}</PropertyNameWrapper>
      </LineItemDescription>
  ) : (<LineItemDescription>{selectedFromFileField.name} ({getFieldTypeLabelByFlag(selectedFromFileField)})</LineItemDescription>));
};

const getFieldTypeLabelByFlag = field => {
  let fieldTypeLabel = "Unknown";
  if (field.isCalculated) {
    fieldTypeLabel = "Calculated";
  }

  if (field.isFromFile) {
    fieldTypeLabel = "From file";
  }

  if (field.isBalanceOverride || field.isFinanceOverride) {
    fieldTypeLabel = "Cashflow override";
  }

  if (field.isHardCoded) {
    fieldTypeLabel = "Manual input";
  }

  if (field.isFromLoanBoss) {
    fieldTypeLabel = "Derived by LoanBoss";
  }

  if (field.isFromRentRoll) {
    fieldTypeLabel = "From rent roll";
  }
  return fieldTypeLabel;
};


const LoanAccordionGroup = props => {
  const {
    loanDscrCalculation,
    setDscrCalculationDashboardSelections,
    dscrCalculations,
    setDscrSetupSelections,
    setDscrLineItemSelections
  } = props;
  const { id, lineItem, loanDscrTotal, name } = loanDscrCalculation;
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (lineItem) {
      const updatedTotalValuesForLoans =
        dscrCalculations &&
        dscrCalculations.map(calc => {
          if (calc.id !== id) {
            return calc;
          }

          return { ...calc, loanDscrTotal: calc.lineItem?.value };
        });
      setDscrSetupSelections({ dscrCalculations: updatedTotalValuesForLoans });
    }
  }, [lineItem]);

  useEffect(() => {
    setIsExpanded(true);
  }, []);

  const handleExpansion = e => {
    if (
      e.target.innerHTML.includes("unfold_") &&
      e.target.tagName.toLowerCase() === "i"
    ) {
      setIsExpanded(prev => !prev);
    }
  };

  const handleAddLineItem = () => {
    setDscrCalculationDashboardSelections({
      isLenderReportingDrawerOpen: true,
      initialDrawerSectionName: "dscr-line-items",
      activeLoanId: id
    });
  };

  const handleEditLineItem = () => {
    setDscrCalculationDashboardSelections({
      isLenderReportingDrawerOpen: true,
      initialDrawerSectionName: "dscr-line-items",
      activeLoanId: id
    });

    if (lineItem.lineItemType === "value") {
      const {
        lineItemType,
        value,
        selectedDscrType,
        calculationFieldsInputValues
      } = lineItem;
      setDscrLineItemSelections({
        isEditing: true,
        lineItemType,
        selectedDscrType,
        calculationFieldsInputValues,
        resultValue: value
      });
    } else {
      const {
        lineItemType,
        value,
        selectedComparisonType1,
        selectedComparisonType2,
        calculatedComparisonValue1,
        calculatedComparisonValue2,
        comparisonCalculationFieldsInputValues1,
        comparisonCalculationFieldsInputValues2
      } = lineItem;
      setDscrLineItemSelections({
        isEditing: true,
        lineItemType,
        resultValue: value,
        selectedComparisonType1,
        selectedComparisonType2,
        calculatedComparisonValue1,
        calculatedComparisonValue2,
        comparisonCalculationFieldsInputValues1,
        comparisonCalculationFieldsInputValues2
      });
    }
  };

  const renderLineItem = () => (
    <LineItemRow
      lineItem={lineItem}
      key={lineItem.id}
      setDscrCalculationDashboardSelections={
        setDscrCalculationDashboardSelections
      }
      loanId={id}
      handleEditLineItem={handleEditLineItem}
    />
  );

  const renderAddNewLineRow = () => (
    <ModuleAccordionSummary
      style={{ paddingTop: "12px", paddingBottom: "12px" }}
      isExpandable={false}
      title={
        <StyledButtonText
          reverse
          label="Add a new line item or comparison"
          iconName="add_circle_outline"
          onClick={handleAddLineItem}
        />
      }
    />
  );

  return (
    loanDscrCalculation && (
      <div style={{ marginBottom: "2em" }}>
        <ModuleAccordionGroup
          onClick={handleExpansion}
          shouldExpandAll={isExpanded}
          shouldCollapseAll={!isExpanded}
          groups={[
            {
              title: name,
              key: id,
              isTitleGroup: false,
              isExpandable: true,
              expandButtonPosition: "left",
              titleAdornmentRight:
                !isExpanded && formattedDollarLabel(loanDscrTotal, "400"),
              sections: [
                lineItem ? renderLineItem() : renderAddNewLineRow(),
                <ModuleAccordionSummary
                  isExpandable={false}
                  title="Projected Debt Service"
                  titleAdornmentRight={formattedDollarLabel(
                    loanDscrTotal,
                    "400"
                  )}
                />
              ]
            }
          ]}
        />
      </div>
    )
  );
};

const DscrProjectedCalculationDashboard = props => {
  const {
    deal,
    user,
    history,
    location,
    isDeleteDialogOpen,
    selectedReportGroup,
    totalDscrValue,
    selectedLoansForDSCR,
    activeLoanId,
    dscrCalculations,
    sourceFileCount,
    fieldCount,
    isLenderReportingDrawerOpen,
    initialDrawerSectionName,
    dscrReportComponent,
    setDscrCalculationDashboardSelections,
    getFieldCountForDeal,
    getReportGroupById,
    getSourceFileCountForDeal,
    setDscrSetupSelections,
    putProjectedReportComponentConfig,
    postProjectedReportComponentConfig,
    putReportConfig,
    match: {
      params: { dealId, reportId, reportComponentId }
    },
    setReportComponentSelections,
    wasNewReportComponentSaved,
    savedReportComponent,
    isSaving,
    wasContentUpdated
  } = props;

  const [showDialog, setShowDialog] = useState(false);

  useEffect(() => {
    if (!selectedReportGroup && reportId) {
      getReportGroupById({ reportGroupId: reportId });
    }
  }, [selectedReportGroup, reportId]);

  useEffect(() => {
    if (_.isEmpty(deal)) {
      props.dealGet({ dealId });
    }

    return () => {
      setDscrSetupSelections({
        selectedLoansForDSCR: [],
        dscrCalculations: null
      });
      setReportComponentSelections({ isSaving: false, isSavingComplete: false, wasNewReportComponentSaved: false, savedReportComponent: null });
    };
  }, [dealId, deal, reportId]);

  useEffect(() => {
    if (Boolean(dealId) || !isLenderReportingDrawerOpen) {
      getFieldCountForDeal({ dealId });
      getSourceFileCountForDeal({ dealId });
    }
  }, [dealId, isLenderReportingDrawerOpen]);

  useEffect(() => {
    if (!selectedLoansForDSCR.length) {
      history.push(`/deal/${dealId}/lender-reports-dscr-config/${reportId}`);
    } else {
      const loansForCalculations =
        selectedLoansForDSCR &&
        selectedLoansForDSCR.map(loan => {
          const existingCalculation =
            dscrCalculations &&
            dscrCalculations.find(calc => calc.id === loan.id);
          if (existingCalculation) {
            return _.cloneDeep(existingCalculation);
          }

          return { ...loan, lineItem: null, loanDscrTotal: null };
        });
      setDscrSetupSelections({ dscrCalculations: loansForCalculations });
    }
  }, [reportComponentId, selectedLoansForDSCR]);

  useEffect(() => {
    if (wasNewReportComponentSaved) {
      setDscrSetupSelections({ dscrReportComponent: savedReportComponent });
    }
  }, [wasNewReportComponentSaved, savedReportComponent]);

  useEffect(() => {
    if (dscrCalculations) {
      const totalDscrValueForReportComponent = dscrCalculations.reduce(
        (sum, val) => (val.loanDscrTotal !== null ? sum + val.loanDscrTotal : sum),
        0
      );
      setDscrSetupSelections({
        totalDscrValue: totalDscrValueForReportComponent
      });
    }
  }, [dscrCalculations, totalDscrValue]);

  const redirectOnSaveOrCancel = () => {
    if (location.state.from === "report-wizard") {
      history.push(`/deal/${dealId}/lender-reports-setup/${reportId}`, {
        from: "undefined-3"
      });
    } else {
      history.push(`/deal/${dealId}/lender-reports/${reportId}`);
    }
  };

  const onSaveFormula = () => {
    if (reportComponentId === "new" && !wasNewReportComponentSaved) {
      const payload = {
        type: "DSCR",
        reportGroupId: reportId,
        createdBy: user.id,
        dealId,
        isProjected: true,
        calculations: { selectedLoans: dscrCalculations, totalDscrValue }
      };
      postProjectedReportComponentConfig({ data: payload });
    } else {
      const payload = {
        ...dscrReportComponent,
        isProjected: true,
        calculations: { selectedLoans: dscrCalculations, totalDscrValue }
      };
      putProjectedReportComponentConfig({
        data: _.omit(payload, ["updatedAt", "createdAt"])
      });
    }

    putReportConfig({
      data: { id: reportId, dscrProjectedLastUpdatedDate: new Date().toISOString() }
    });

    setDscrCalculationDashboardSelections({
      wasContentUpdated: false
    });
  };

  const onCancelSaving = () => {
    setDscrCalculationDashboardSelections({
      wasContentUpdated: false
    });
    redirectOnSaveOrCancel();
  };

  const onBackButtonClick = () => {
    if (wasContentUpdated) {
      setShowDialog(true);
    } else {
      redirectOnSaveOrCancel();
    }
  };

  const onConfirmDialog = () => {
    onSaveFormula();
    setShowDialog(false);
    redirectOnSaveOrCancel();
  };

  const closeDrawer = () => {
    setDscrCalculationDashboardSelections({
      isLenderReportingDrawerOpen: false,
      initialDrawerSectionName: null
    });
  };

  const saveFormulaButton = {
    label: isSaving ? "Saving..." : "Save",
    onClick: onSaveFormula,
    disabled: isSaving
  };
  const cancelFormulaButton = {
    label: "Cancel changes",
    onClick: onCancelSaving
  };

  const handleCloseDeleteLineItemDialog = () => {
    setDscrCalculationDashboardSelections({
      isDeleteDialogOpen: false,
      activeLoanId: null
    });
  };

  const handleLineItemDelete = () => {
    const updatedCalculations = dscrCalculations.map(calc => {
      if (calc.id !== activeLoanId) {
        return calc;
      }

      return { ...calc, lineItem: null, loanDscrTotal: null };
    });
    setDscrCalculationDashboardSelections({
      isDeleteDialogOpen: false,
      activeLoanId: null
    });
    setDscrSetupSelections({ dscrCalculations: updatedCalculations });
  };

  // components

  const heroCardContents = () => {
    if (!selectedReportGroup) {
      return null;
    }
    const { reportName, frequency, firstReportDueDate } = selectedReportGroup;

    return (
      <ListItemContent>
        <ListItemTitle>{reportName}</ListItemTitle>
        <ListItemText>
          {`Published ${frequency} and started on ${moment
            .utc(firstReportDueDate)
            .format("MMMM Do, YYYY")}`}
        </ListItemText>
      </ListItemContent>
    );
  };

  const heroCard = () => {
    if (!deal) {
      return null;
    }

    return (
      <StickyWrapper>
        <CustomizableHeroCard
          {...props}
          buttons={[saveFormulaButton, cancelFormulaButton]}
          cardContent={heroCardContents()}
          title={deal.name}
          backLabel="All calculations"
          onBackButtonClick={onBackButtonClick}
        />

        <LabeledIconWrapper>
          <Container>
            <LabeledButtonWithCount
              label="Source Files"
              icon={<FolderIcon />}
              count={sourceFileCount}
              style={{
                width: "100%",
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                backgroundColor: "#fff"
              }}
              onClick={() => setDscrCalculationDashboardSelections({
                isLenderReportingDrawerOpen: true,
                initialDrawerSectionName: "source-file-management"
              })}
            />
            <LabeledButtonWithCount
              label="Fields"
              icon={
                <img src={calcIcon} alt="Field Icon" height={18} width={18} />
              }
              count={fieldCount}
              style={{
                width: "100%",
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
                backgroundColor: "#fff"
              }}
              onClick={() => setDscrCalculationDashboardSelections({
                isLenderReportingDrawerOpen: true,
                initialDrawerSectionName: "field-management"
              })}
            />
          </Container>
        </LabeledIconWrapper>
      </StickyWrapper>
    );
  };

  const body = () => (
    <div style={{ flexDirection: "column" }}>
      <div style={{ marginBottom: 20 }}>
        <ConfigPageDisclaimer
          style={{ marginBottom: 20, backgroundColor: "white" }}
        />
      </div>
      {dscrCalculations?.map(dscrLoanCalc => (
        <LoanAccordionGroup
          loanDscrCalculation={dscrLoanCalc}
          {...props}
          key={dscrLoanCalc.id}
        />
      ))}
      <ModuleAccordionSection
        isExpandable={false}
        title={
          <LabelString value="Projected Total" lines={1} style={{ fontSize: "18px" }} />
        }
        titleAdornmentRight={formattedDollarLabel(totalDscrValue, "400")}
        style={{ borderRadius: "8px", backgroundColor: "#FFFFFF" }}
      />
    </div>
  );

  return (
    <>
      <CardPageLayout
        isReversed
        bannerImageUrl={deal && deal.imageLarge}
        cardComponent={heroCard()}
        bodyComponent={body()}
      />
      <LenderReportingDrawer
        authentication={props.authentication}
        closeDrawer={closeDrawer}
        deal={deal}
        initialDrawerSectionName={initialDrawerSectionName}
        isOpen={isLenderReportingDrawerOpen}
      />
      <SimpleConfirmDialog
        title="Confirm Delete"
        message="Are you sure you want to delete?"
        modalOpen={isDeleteDialogOpen}
        handleNo={handleCloseDeleteLineItemDialog}
        handleYes={handleLineItemDelete}
        noText="Cancel"
        yesText="Delete"
      />
      <UserConfirmationModal
        open={showDialog}
        onClose={() => setShowDialog(false)}
        onCancelClick={onCancelSaving}
        onConfirmClick={onConfirmDialog}
      />
    </>
  );
};

const mapStateToProps = ({
  lenderReportList,
  lenderReportsDscrSetup,
  lenderReportsDscrCalculation,
  lenderReportingReportComponent,
  newDeal: { deal },
  authentication: { user }
}) => ({
  ...lenderReportsDscrSetup,
  ...lenderReportList,
  ...lenderReportsDscrCalculation,
  ...lenderReportingReportComponent,
  deal,
  user
});

const mapDispatchToProps = dispatch => bindActionCreators(
  {
    dealGet,
    ...dashboardActionCreators,
    ...dscrCalculationActionCreators,
    ...dscrSetupActionCreators,
    ...dscrDrawerActionCreators,
    ...reportComponentActionCreators,
    ...reportConfigActionCreators
  },
  dispatch
);

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(DscrProjectedCalculationDashboard);
